import { RandomId } from "@swivl-mono/helpers";
import { NodeData_StoreFinderLookup, NodeData_UserValidationNode, NodeInterface, NodeType, VarKey } from "@swivl-mono/types";
import { Input, RadioButtons, Select, SelectItem, Switch } from "@swivl-mono/ui";

import UserVariablesDropdown from "../../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import { TagInput } from "../../../../../Components/TagInput/TagInput";
import TabNodeLayoutData from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";

const UserValidationNode = {
  Type: NodeType.UserValidation,
  Empty: function () {
    const node = {
      id: RandomId(6),
      type: NodeType.UserValidation,
      phoneNumberVar: VarKey.UserTempPhoneNumber,
      action: "VALIDATE",
      codeName: "Two Factor Code",
      revalidate: false,
      goto: "",
      invalidGoto: "",
      smsMessage: "Your verification code is {CODE}.",
      inputMessage: "Please enter the code sent to your phone number.",
      validateForTimeInMinutes: 60 // default to 60 minutes
    } as NodeData_UserValidationNode;

    return node; //
  },
  PlumbData: function (_node: NodeInterface) {
    const node = _node as NodeData_UserValidationNode;
    if (node.action === "SEND_CODE") {
      let tabs = [
        {
          id: "goto",
          source: "goto",
          target: node.goto,
          title: "Code Valid"
        },
        {
          id: "invalidGoto",
          source: "invalidGoto",
          target: node.invalidGoto,
          title: "Invalid Code"
        }
      ];
      return TabNodeLayoutData({
        node: node,
        title: "Validate User - Send Code",
        baseWidth: 150,
        tabs: tabs
      });
    }
    let tabs = [
      {
        id: "goto",
        source: "goto",
        target: node.goto,
        title: "Validated"
      },
      {
        id: "invalidGoto",
        source: "invalidGoto",
        target: node.invalidGoto,
        title: "Not Validated"
      }
    ];
    return TabNodeLayoutData({
      node: node,
      title: "Validate User - Validate",
      baseWidth: 150,
      tabs: tabs
    });
  },
  InspectorPanel: class InputInspectorPanel extends NodePanel {
    constructor(props) {
      super(props);
      this.filterToggled = this.filterToggled.bind(this);
    }
    filterToggled(name: string, on: boolean) {
      let node: NodeData_StoreFinderLookup = { ...this.props.node } as NodeData_StoreFinderLookup;
      node.filterStores = on;
      if (on) {
        node.filterVariableId = VarKey.UserFilterFeatures;
      } else {
        delete node.filterVariableId;
      }
      this.props.updateNode(node, this.props.node);
    }

    render() {
      const node = this.props.node as NodeData_UserValidationNode;

      return (
        <div>
          <div className="panel message_panel">
            <InspectorNodeHeader title="Validation" />
            <RadioButtons
              options={[
                { value: "VALIDATE", label: "Validate" },
                { value: "SEND_CODE", label: "Send 2fa" }
              ]}
              name="action"
              value={node.action}
              onChange={this.onChange}
            />

            <label>Phone Number Variable</label>
            <UserVariablesDropdown onChange={this.onChange} skipUserId={true} name={"phoneNumberVar"} value={node.phoneNumberVar} />

            {node.action === "SEND_CODE" && (
              <div className="form-group">
                <Input label="Code Name" value={node.codeName} onChange={this.onChange} name="codeName" containerClassName="mb-3" />
                <Select
                  label="Stay validated for"
                  hideClear
                  selectedValues={[String(node.validateForTimeInMinutes || 60)]}
                  options={
                    [
                      { value: "1", label: "1 Minute" },
                      { value: "5", label: "5 Minutes" },
                      { value: "15", label: "15 Minutes" },
                      { value: "30", label: "30 Minutes" },
                      { value: "60", label: "1 Hour" },
                      { value: "120", label: "2 Hours" },
                      { value: "1440", label: "1 Day" }
                    ] as SelectItem[]
                  }
                  onChange={(vals) => this.onChange({ target: { name: "validateForTimeInMinutes", value: Number(vals[0]) } } as any)}
                />
                <TagInput label="SMS Message" value={node.smsMessage} onChange={this.onChange} name="smsMessage" />

                <TagInput label="2fa Input Message" value={node.inputMessage} onChange={this.onChange} name="inputMessage" />
                <label>Revalidate</label>
                <Switch name="revalidate" on={node.revalidate ? true : false} onChange={this.onChange} />
                {node.revalidate && <small>This will send the 2fa code reguardless of the user currently being validated.</small>}
              </div>
            )}
          </div>
          <InspectorFooter deleteNode={this.deleteNode} node={node} />
        </div>
      );
    }
  }
};
export default UserValidationNode;
